export default __webpack_public_path__ + "static/physical_and_chemical-5b5f42d287a241f07c47d1303b5fba4d.jpg";